import {create} from 'zustand';
import {FavoriteButtonProps} from './types';

interface FavoriteDoctorUpdatedStore {
	favoriteDoctorUpdated: FavoriteButtonProps | null;
	setFavoriteDoctorUpdated: (doctor: FavoriteButtonProps | null) => void;
}

const useFavoriteDoctorUpdatedStore = create<FavoriteDoctorUpdatedStore>(set => ({
	favoriteDoctorUpdated: null,
	setFavoriteDoctorUpdated: (doctor: FavoriteButtonProps | null) => set({favoriteDoctorUpdated: doctor}),
}));

export {useFavoriteDoctorUpdatedStore};
